import { render } from "./ListaUsuario.vue?vue&type=template&id=195abd1b&ts=true"
import script from "./ListaUsuario.vue?vue&type=script&lang=ts"
export * from "./ListaUsuario.vue?vue&type=script&lang=ts"

import "./ListaUsuario.vue?vue&type=style&index=0&id=195abd1b&lang=css"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__